
<template>
  <div>
    <form-step
      :checked="checked"
      :validated="validated"
      :declined="declined"
      :checkLoading="checkLoading"
      :onSubmit="onSubmit"
      stepName="Customer"
      @reset="$emit('reset')"
      @check="$emit('check', true)"
      @edit="$emit('check', false)"
      @nextStep="$emit('next')">
      <template #title>Who is your customer?</template>
      <template #form>
        <company-selector id="company-search-element"
          :value="value" @input="$emit('input', $event)"
          placeholder="Enter customer name"
          noOptionsText="Start typing to search for your customer's company name." />
      </template>

      <template #billboard>
        <div v-if="!declined">
          <!-- alert success -->
          <div class="row justify-content-center">
            <h1 class=""><icon icon="check-circle" class="text-success"/></h1>
            <h2 class="mb-4 mx-5">OK! We can cover this buyer</h2>
          </div>
          <!-- explanatory cards -->
          <div class="card-deck ">
            <help-card :content="cards.recentInvoice"/>
            <div class="w-100 d-none d-sm-block d-md-none mb-4"><!-- wrap every 2 on sm--></div>
            <help-card :content="cards.existingDistress"/>
          </div>
        </div>
        <div v-else>
          <error-display title="Unfortunately we cannot accept your request" :body="checked.rejection_reason.detail"></error-display>
        </div>
      </template>
    </form-step>
  </div>
</template>

<script>
import FormStep from '@/components/FormStep'
import CompanySelector from '@/components/CompanySelector'

import HelpCard from '@/components/HelpCard'
import protectCards from '@/data/protectCards'
import ErrorDisplay from '@/components/ErrorDisplay'

export default {
  name: 'debtor',
  components: {
    FormStep,
    CompanySelector,
    HelpCard,
    ErrorDisplay
  },
  props: {
    checked: Object,
    validated: Boolean,
    checkLoading: Boolean,
    onSubmit: Function,
    value: {}
  },
  data: function () {
    return {
      cards: protectCards
    }
  },
  computed: {
    declined: function () { return this.checked ? this.checked.status === 'rejected' : false }
  }
}
</script>
